import { render, staticRenderFns } from "./EditNicknameModal.vue?vue&type=template&id=5fc726be&scoped=true"
import script from "./EditNicknameModal.vue?vue&type=script&lang=js"
export * from "./EditNicknameModal.vue?vue&type=script&lang=js"
import style0 from "./EditNicknameModal.vue?vue&type=style&index=0&id=5fc726be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc726be",
  null
  
)

export default component.exports